import { render, staticRenderFns } from "./showActivityAuditorium.vue?vue&type=template&id=400abb5c&scoped=true"
import script from "./showActivityAuditorium.vue?vue&type=script&lang=js"
export * from "./showActivityAuditorium.vue?vue&type=script&lang=js"
import style0 from "./showActivityAuditorium.vue?vue&type=style&index=0&id=400abb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400abb5c",
  null
  
)

export default component.exports